// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2EhMv","title":"AfterFrontImage_title__CIMSJ"};